/**
 * API Configuration for different environments
 */

export interface ApiConfig {
  baseUrl: string;
  timeout: number;
  retryAttempts: number;
  retryDelay: number;
}

const getApiConfig = (): ApiConfig => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isProduction = process.env.NODE_ENV === 'production';
  
  // Default configuration
  const defaultConfig: ApiConfig = {
    baseUrl: '/api',
    timeout: 30000, // 30 seconds
    retryAttempts: 3,
    retryDelay: 1000, // 1 second
  };

  // Environment-specific overrides
  if (isDevelopment) {
    return {
      ...defaultConfig,
      baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api',
      timeout: 60000, // Longer timeout for development
    };
  }

  if (isProduction) {
    return {
      ...defaultConfig,
      baseUrl: process.env.REACT_APP_API_BASE_URL || '/api', // Relative URL for same-origin
      retryAttempts: 2, // Fewer retries in production
    };
  }

  return defaultConfig;
};

export const apiConfig = getApiConfig();

/**
 * IAP Configuration for Google Cloud
 */
export interface IapConfig {
  enabled: boolean;
  audience: string;
  projectId: string;
}

export const iapConfig: IapConfig = {
  enabled: process.env.REACT_APP_IAP_ENABLED === 'true',
  audience: process.env.REACT_APP_IAP_AUDIENCE || '',
  projectId: process.env.REACT_APP_GOOGLE_CLOUD_PROJECT || 'mike-playground-225822',
};

/**
 * Feature flags for the application
 */
export interface FeatureFlags {
  enableRetry: boolean;
  enableSoftDelete: boolean;
  enableAdvancedSearch: boolean;
  enableBulkOperations: boolean;
}

export const featureFlags: FeatureFlags = {
  enableRetry: process.env.REACT_APP_ENABLE_RETRY !== 'false',
  enableSoftDelete: process.env.REACT_APP_ENABLE_SOFT_DELETE !== 'false',
  enableAdvancedSearch: process.env.REACT_APP_ENABLE_ADVANCED_SEARCH !== 'false',
  enableBulkOperations: process.env.REACT_APP_ENABLE_BULK_OPERATIONS === 'true',
};
